import Link from 'next/link'

type StyleType = 'none' | 'solid' | 'outline' | null | undefined
type SizeType = 'large' | 'default' | 'small' | null | undefined
type AsType = 'button' | 'submit' | null | undefined

type ButtonProps = {
  id?: string
  href: string
  target?: string
  children: React.ReactNode
  className?: string
  style?: StyleType
  size?: SizeType
  as?: AsType
  disabled?: boolean
  ariaLabel?: string
  rel?: 'noopener' | 'noreferrer' | 'noopener noreferrer' | ''
}

export default function Button({
  id,
  href,
  target = '_self',
  className,
  children,
  style = 'solid',
  size = 'default',
  as = null,
  disabled = false,
  ariaLabel = '',
  rel = '',
}: ButtonProps): JSX.Element {
  const buttonStyle = `btn btn--${style} btn--${size} ${className}`

  if (as === 'button') {
    return (
      <button
        type="button"
        id={id}
        className={buttonStyle}
        disabled={disabled}
        aria-label={ariaLabel}>
        {children}
      </button>
    )
  }

  if (as === 'submit') {
    return (
      <button
        type="submit"
        id={id}
        className={buttonStyle}
        disabled={disabled}
        aria-label={ariaLabel}>
        {children}
      </button>
    )
  }

  return (
    <Link
      id={id}
      href={href}
      target={target ?? '_self'}
      className={buttonStyle}
      aria-label={ariaLabel}
      rel={rel}>
      {children}
    </Link>
  )
}
